jQuery(document).ready(function($){
    
    //
    // Scrolling
    //

    $(document).on('click', 'a.scroll', function (e) {
        var $target = $(this.hash);
        if (!$target.length)
            $target = $('[name=' + this.hash.slice(1) + ']');
        scrollTo($target);
    });

    $(document).on('click', '.mega-menu-wrap ul li .mega-sub-menu li a', function (e) {
        $('.mega-menu-toggle').toggleClass('mega-menu-open');
        var $target = $(this.hash);
        if (!$target.length)
            $target = $('[name=' + this.hash.slice(1) + ']');
        scrollTo($target);
    });

    function scrollTo($element) {
        $("body, html").animate({
            scrollTop: $element.offset().top
        }, 600);
    }




    //
    // Mobile Nav
    //
    $(document).on('click', '.menu-button', function(e) {
        e.preventDefault();
        $('.side-menu, .side-menu-overlay').addClass('active');
        $('body').addClass('menu-active');
    });

    $(document).on('click', '.side-menu--close, .side-menu-overlay.active', function(e) {
        e.preventDefault();
        $('.side-menu, .side-menu-overlay').removeClass('active');
        $('body').removeClass('menu-active');
    });

    var $sideMenu = $('.side-menu__content .menu');

    var createSubMenuToggle = function () {
        return $('<div><a href="#"><i class="fa fa-plus" aria-hidden="true"></i></a></div>').addClass('side-menu__sub-menu-toggle')
    }

    $sideMenu.find('.menu-item-has-children').each(function(i, item) {
        item.appendChild(createSubMenuToggle()[0])
    })

    $(document).on('click', '.side-menu__sub-menu-toggle a', function(e){
        e.preventDefault();

        var $this = $(this)
        var $parent = $this.closest('.menu-item')
        var $subMenu = $parent.find('.sub-menu')

        if (!$subMenu.hasClass('sub-menu-open')) {
            $this.addClass('sub-menu-toggle-active');
            $subMenu.addClass('sub-menu-open').slideDown();
        } else {
            $this.removeClass('sub-menu-toggle-active');
            $subMenu.removeClass('sub-menu-open').slideUp();
        }
    });

});



